import React, { Component } from "react";
import { BrowserRouter, Route, Link, Switch } from "react-router-dom";
import App from "./App.js";
import "./App.css";
import "./index.css";
import Navbar from "./navbar.js";

class Home extends Component {
  render() {
    return (
      <BrowserRouter>
        <Navbar />
        <div
          style={{
            backgroundColor: "#eaebec",
            //"#eaebec",
            height: "calc(100vh - 55px)",
          }}
        >
          <Switch>
            <Route exact path="/" component={App}></Route>
          </Switch>
        </div>
      </BrowserRouter>
    );
  }
}

export default Home;
